<div class="preloader-wrapper big active" *ngIf="isShow">
    <div class="bg-block" *ngIf="background"></div>
    <div class="load-container load4">
        <div class="loader"></div>
    </div>
</div>